import { render, staticRenderFns } from "./AISalesContent.vue?vue&type=template&id=d6b6f10c&scoped=true&"
import script from "./AISalesContent.vue?vue&type=script&lang=js&"
export * from "./AISalesContent.vue?vue&type=script&lang=js&"
import style0 from "./AISalesContent.vue?vue&type=style&index=0&id=d6b6f10c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b6f10c",
  null
  
)

export default component.exports